import { createContext, Dispatch, SetStateAction, useState } from 'react';
import { ContactDetails } from '../../components/investment-robot/forecast-screen/email-me-modal/ForecastEmailMeCard';

type ContactDetailsContextType = {
    contactDetails: ContactDetails,
    setContactDetails: Dispatch<SetStateAction<ContactDetails>> | undefined,
}

export const ContactDetailsContext = createContext<ContactDetailsContextType>({
    contactDetails : {
        name: '',
        email: '',
        phone: '',
        advisorEmail: '',
        call: false,
        validInput: false,
    },
    setContactDetails : undefined,
});

export const WithContactDetails: React.FC<{}> = ({
    children
}) => {
    const [contactDetails, setContactDetails] = useState<ContactDetails>({
        name: '',
        email: '',
        phone: '',
        advisorEmail: '',
        call: false,
        validInput: false,
    });

    return (
        <ContactDetailsContext.Provider value={{
                contactDetails: contactDetails,
                setContactDetails: setContactDetails,
        }}>
            {children}
        </ContactDetailsContext.Provider>
    
    );
};